declare global {
  interface Window {
    dataLayer: unknown[][];
    gtag(...args: unknown[]): void;
  }
}

let initialized = false;

export function initAnalytics(measurementId: string): void {
  if (initialized) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function (...args: unknown[]) {
    window.dataLayer.push(args);
  };
  window.gtag('js', new Date());
  // Must be called before config so GA4 doesn't suppress hits in consent-required regions (UK/EEA)
  window.gtag('consent', 'default', { analytics_storage: 'granted' });
  window.gtag('config', measurementId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}

function callGtag(eventName: string, params?: Record<string, unknown>): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params);
}

export function trackEvent(eventName: string, params?: Record<string, unknown>): void {
  callGtag(eventName, params);
}

export function trackPageView(path: string): void {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_path: path });
}

export function trackWaitlistSignup(): void {
  callGtag('waitlist_signup');
}

export function trackLogin(): void {
  callGtag('login', { method: 'Auth0' });
}

export function trackRecipeImport(method?: string): void {
  callGtag('recipe_import', method ? { import_method: method } : undefined);
}

export function trackRecipeView(recipeId: string): void {
  callGtag('recipe_view', { recipe_id: recipeId });
}
